import { useCallback } from 'react'
import { store } from '../..';
import { setProps } from '../../redux/actions';
import { connect } from 'react-redux';

export const findAliasJson = (data, alias) => {
    // Iterate through each element in the array
    // Iterate over the data array
    for (let item of data) {
        // Check if alias matches in mainConfig
        if (item.mainConfig && item.mainConfig?.length) {
            for (let mainItem of item.mainConfig) {
                if (mainItem.alias === alias) {
                    return mainItem; // Return if alias is found in mainConfig
                }

                // Check dependencies recursively within mainConfig
                if (mainItem.dependancy && mainItem.dependancy?.length) {
                    for (let depItem of mainItem.dependancy) {
                        if (depItem.alias === alias) {
                            return depItem; // Return if alias is found in dependencies of mainConfig
                        }
                    }
                }
            }
        }

        // Check if alias matches in commonConfig
        if (item.commonConfig && item.commonConfig?.length) {
            for (let commonItem of item.commonConfig) {
                if (commonItem.alias === alias) {
                    return commonItem; // Return if alias is found in commonConfig
                }

                // Check dependencies recursively within commonConfig
                if (commonItem.dependancy && commonItem.dependancy?.length) {
                    for (let depItem of commonItem.dependancy) {
                        if (depItem.alias === alias) {
                            return depItem; // Return if alias is found in dependencies of commonConfig
                        }
                    }
                }
            }
        }
    }
    return null;  // Return null if alias is not found
}

export const handleRedirection = async (props) => {
    // get updated value from redux store
    const getCurrentState = () => {
        return store.getState()
    }

    // redirected
    if (getCurrentState().redirectFromConfigration?.redirect == 1) {
        // from where i should take last url 
        getCurrentState().redirectFromConfigration?.configRedirection.push(getCurrentState().redirectFromConfigration?.url)
        await props.setProps({ redirectFromConfigration: { ...getCurrentState()?.redirectFromConfigration, url: '', redirect: 0 } })
    }
    // back pressed
    else if (getCurrentState().redirectFromConfigration?.redirect == 2) {
        const newConfigArray = getCurrentState().redirectFromConfigration?.configRedirection?.slice(0, -1)
        await props.setProps({ redirectFromConfigration: { configRedirection: newConfigArray, url: '', redirect: 0 } })
    }
    else {
        await props.setProps({
            redirectFromConfigration: {
                redirect: 0,
                configRedirection: [],
                url: ''
            }
        })
    }
}

const useBizConfig = () => {

    const filterStatusAndRequired = (data) => {
        let result = [];
        let seenAliases = new Set();
    
        // Function to check the status and required conditions for dependency objects
        function traverse(node) {
            // If the node has a dependency, we check it.
            if (node?.dependancy && Array.isArray(node?.dependancy)) {
                node.dependancy?.forEach((dependency) => {
                    // Check the status and required conditions for each dependency
                    if (!seenAliases?.has(dependency.alias) && dependency?.status === 0 && dependency?.required === 1) {
                        seenAliases.add(dependency.alias);
                        result.push(dependency);
                    }
                });
    
                // Recurse into dependancies of dependencies if they exist
                node.dependancy?.forEach(traverse);
            }
        }
    
        // Start the traversal
        traverse(data);
        return result;
    };
    
    const processConfig = useCallback((config) => {
        // Arrays to hold the processed configurations
        const commonConfig = [];
        const mainConfig = [];

        // A set to keep track of processed aliases to avoid duplication
        const processedAliases = new Set();

        // Recursive function to traverse the configuration
        const traverse = (item, parentIsCommonConfig = false) => {
            // Destructure the item to extract necessary properties
            const { dependancy = [], iscommonconfig, ...rest } = item;

            // Determine if the current item should be part of commonConfig
            // If the parent item is marked as a common config, the current item should inherit that status
            // Otherwise, it will be based on the item's own iscommonconfig flag
            const isCommon = parentIsCommonConfig || iscommonconfig;

            // Process dependencies first, before processing the current item
            dependancy?.forEach((dep) => {
                // Check if the dependency alias hasn't been processed already and if its status is valid (status === 0)
                if (!processedAliases?.has(dep.alias)) {
                    // Recursively traverse the dependency, passing the common config status from the parent
                    traverse(dep, isCommon); // Pass down the parent's common config status
                }
            });

            // Process the current item after its dependencies have been processed
            // Make sure the current item hasn't been processed already (to avoid duplicates)
            if (!processedAliases?.has(item.alias)) {
                // Mark the current alias as processed to avoid duplication
                processedAliases.add(item.alias);

                // Create a new object with the remaining properties (rest) and the necessary flags
                const processedItem = { ...rest, iscommonconfig, dependancy };

                // Depending on whether this item is part of common config, push it to the corresponding array
                if (isCommon) {
                    commonConfig.push(processedItem); // Add to commonConfig if it is a common config
                } else {
                    mainConfig.push(processedItem); // Add to mainConfig if it is not a common config
                }
            }
        };

        if(config?.ignoremainobject){
            // Start traversal from the dependencies only, skipping the root object itself
            config.dependancy?.forEach((dep) => traverse(dep));
        }
        else {
             // Start the traversal from the root of the configuration
            traverse(config);
        }

        delete config?.dependancy
        // Return both the commonConfig and mainConfig arrays
        return { ...config, commonConfig, mainConfig };
        // return { commonConfig, mainConfig };
    }, [])

    // check module status
    const checkConfigStatus = useCallback((config) => {
        function checkStatus(arr) {
            return arr?.every(item => item.required === 1 ? ((item.status === 1) || item.status === 2) : true);
        }

        return (checkStatus(config?.commonConfig) && checkStatus(config?.mainConfig)) ? 1 : 0;
    }, [])

    return {
        findAliasJson,
        filterStatusAndRequired,
        processConfig,
        checkConfigStatus
    }

}

const mapStateToProps = state => ({
    redirectFromConfigration: state.redirectFromConfigration,
    
})
const mapDispatchToProps = dispatch => ({
    setProps: (payload) => dispatch(setProps(payload)),
})

export default useBizConfig
connect(mapStateToProps, mapDispatchToProps)(handleRedirection)